import { render, staticRenderFns } from "./ResponsibleStay.vue?vue&type=template&id=f590681a&scoped=true"
import script from "./ResponsibleStay.vue?vue&type=script&setup=true&lang=ts"
export * from "./ResponsibleStay.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ResponsibleStay.vue?vue&type=style&index=0&id=f590681a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f590681a",
  null
  
)

export default component.exports